(() => {
  if (customElements.get('featured-slider') || !window.Splide) {
    return;
  }

  class FeaturedSlider extends HTMLElement {
    constructor() {
      super();
      this.gap = this.dataset.gap ?? '2.4rem';
      this.mobileSlides =
        typeof this.dataset.mobileSlides === 'undefined' ? 1 : parseInt(this.dataset.mobileSlides, 10);
      this.options = {
        perPage: 3,
        pagination: false,
        gap: this.gap,
        perMove: 1,
        breakpoints: {
          989: {
            perPage: 2,
          },
          749: {
            perPage: this.mobileSlides,
          },
        },
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new window.Splide(this.querySelector('.js-slider'), this.options).mount();
    }
  }

  customElements.define('featured-slider', FeaturedSlider);

  class ArticleImageGallerySlider extends FeaturedSlider {
    constructor() {
      super();
      this.arrows = true;
      this.options = {
        perPage: 2,
        pagination: false,
        gap: '2.4rem',
        perMove: 1,
        type: 'loop',
        breakpoints: {
          3000: {
            perPage: 2,
            padding: { left: '12.5%', right: '12.5%' },
          },
          1440: {
            perPage: 1,
            padding: { left: '25%', right: '25%' },
          },
          989: {
            perPage: 1,
            padding: { left: '2rem', right: '2rem' },
            gap: '0.8rem',
          },
        },
      };
    }
  }

  customElements.define('article-image-gallery-slider', ArticleImageGallerySlider);
})();
